<template>
  <el-pagination style="margin-top: 5px;"
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 :current-page="pagination.currentPage"
                 :page-sizes="Pagesize"
                 :page-size="getpageSize()"
                 background
                 :pager-count="pagerCount"
                 :layout="layout"
                 :total="pagination.total">
  </el-pagination>
</template>
<script>

  export default {
    name: "pagination",
    data() {
      return {
        Pagesize: [10,15,20,50],
      }
    },
    props: {
      layout:{
        default:"total, sizes, prev, pager, next, jumper"
      },
      pagination: {
        type: Object,
        default: {
          pageSize: 0,
          currentPage: 1,
          total: 0,
        }
      },
      pagerCount:{
        default:7
      },
      showlagersize:{
        default:false
      }
    },
    watch: {
      pagination: {
        deep: true,
        handler (val) {
          if(val.total>0&&(val.total<val.pageSize*(val.currentPage-1))){
            this.handleCurrentChange(1);
          }
        }
      }
    },
    methods: {
      getpageSize() {
        if (this.pagination.pageSize == 0) {
          var CH = document.documentElement.clientHeight;
          this.pagination.pageSize = CH >= 1000 ? 20 : (CH >= 800 ? 15 : 10);
        }
        return this.pagination.pageSize;
      },
      handleSizeChange(val) {
        this.pagination.currentPage=1
        this.pagination.pageSize = val
        this.bindGrid()
      },
      handleCurrentChange(val) {
        this.pagination.currentPage = val
        this.bindGrid()
      },
      bindGrid() {
        this.$emit('bindgrid')
      },
    },
    mounted() {
      if (this.showlagersize)
        this.Pagesize = [10, 15, 20, 50, 100, 500, 1000, 2000];
    }

  }
</script>


<style scoped>
  .user {
    background-color: #ff0000;
    width: 300px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue